<template>
  <transition :name="routerTransition">
    <div
      v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
      class="header-title router-header"
    >
      <div class="content-area__heading" :class="$route.meta.breadcrumb">
        <strong class="route-title">{{ routeTitle }}</strong>
      </div>
      <!-- BREADCRUMB -->
      <vx-breadcrumb
        class="md:block hidden font-normal"
        v-if="$route.meta.breadcrumb"
        :route="$route"
        :isRTL="$vs.rtl"
      />
    </div>
  </transition>
</template>

<script>
import themeConfig from "@/../themeConfig.js";

export default {
  data() {
    return {
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
  },
  computed: {
    activeUserInfo() {
      return JSON.parse(localStorage.getItem("userDetails"));
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    logout() {
      //console.log('logout');

      /* FIXME: Uncomment For Actual Functionality */
      // Logout API call
      this.$axiosSecure
        .post(`/logout`)

        .then((response) => {
          //console.log(response);
          if (response) {
            // Clear user details
            this.$store.dispatch("auth/clearAuthenticatedUser");
            // Google logout
            // this.$gAuth.signOut();
            // Set isPartner View to false if partner logs out
            // this.$store.dispatch("setPartnerView", false);
            // Redirect to login
            this.$router.replace("/login");
          }
        })
        .catch((error) => {
          // If user is not logged in
          if (error.response.status == 401) {
            // Clear user details
            this.$store.dispatch("auth/clearAuthenticatedUser");
            // Redirect to login
            this.$router.replace("/login");
          }
        });
    },
    activityLog() {
      this.$router.push({ path: "/activity-log" });
    },
    addPromoReq() {
      this.$router.push({ path: "/cnic-promo-request" });
    },
  },
};
</script>
